import fp from 'lodash/fp';
import React from 'react';
import { config } from '@factorin/container.macro';
import { rawRequest } from '@factorin/rest';

import { wrapRequest } from 'Modules/core/api';
import { connect } from 'Modules/core/redux';
import { Icon, Label, Text, Button } from 'Modules/ui2/components';
import warning from 'Modules/ui2/icons/warning.sprite.svg';

import styles from '../common.module.scss';


class ResendLetterComponent extends React.PureComponent {
    state = {
        timer: this.props.timer,
    };

    componentDidMount() {
        const { timer } = this.props;
        if (timer > 0)
            this.timer = setInterval(this.tick, 1000);
    }

    tick = () => this.setState(({ timer }) => {
        if (timer === 0)
            return clearInterval(this.timer);
        return { timer: timer - 1 };
    });

    resendLetter = async () => {
        const { t, setStage, email, clientOfficeUri = '' } = this.props;
        try {
            await wrapRequest(rawRequest, {
                method: 'POST',
                url: fp.pipe(fp.compact, fp.join(''))([
                    clientOfficeUri || config.basePath,
                    '/api/v1',
                    '/registration/confirmcode',
                ]),
                params: { email },
            });
            setStage('success', { email });
        } catch (error) {
            setStage('failure', { error: fp.get('response.data.Title', error) || t('failure.unknown') });
        }
    };

    render() {
        const { t, setStage } = this.props;
        const { timer } = this.state;
        return (
            <>
                <Icon icon={warning} className={styles.infoIcon} size='48' />
                <Label component='h3' weight='demibold' textSize='21-24'>
                    {t('resending.title')}
                </Label>
                <Text component='p' textSize='18'>
                    {timer === 0
                        ? t('resending.description')
                        : t('resending.await', {
                            minutes: Math.floor(timer / 60),
                            seconds: `${timer % 60}`.padStart(2, '0'),
                        })}
                </Text>
                <div className={styles.buttons}>
                    {timer === 0 && (
                        <Button variant='normal' size='56' type='button' onClick={this.resendLetter}>
                            {t('resending.buttons.send')}
                        </Button>
                    )}
                    <Button variant='secondary' size='56' type='button' secondary onClick={() => setStage('form')}>
                        {t('resending.buttons.cancel')}
                    </Button>
                </div>
            </>
        );
    }
}

export const ResendLetter = connect(
    state => ({
        clientOfficeUri: fp.get('config.clientofficeUrl', state),
    }),
)(ResendLetterComponent);
